<ng-container
  *ngTemplateOutlet="itemTemplate; context: {$implicit: item, selectItem: selectItem, selected: selected}">
</ng-container>
